import documentReady from 'document-ready';
import FormControl from 'legacy/form_control';
import $ from 'legacy/jquery';
import { preventDefaultPlaceholderAnchorTags } from 'legacy/util/prevent_default_placeholder_anchor_tags';

documentReady(() => {
  function registerEvents() {
    $('#attachment').on('change', toggleSubmitButton);
    $('#notes').on('keyup', toggleSubmitButton);
    $('#take_home_test_form').on('submit', disableSubmit);

    FormControl.attachOrPaste('.attach-or-paste', {
      uploadFinished: uploadFinished,
      attachmentRemoved: toggleSubmitButton,
    });
  }

  function uploadFinished(field) {
    const index = parseInt(field.match(/file_(\d*)/)[1], 10);

    if (fileAttached(index)) {
      $(".attach-or-paste[data-field='file_" + (index + 1) + "']").show();
    }

    toggleSubmitButton();
  }

  function toggleSubmitButton() {
    const notes = $('#notes').val();
    const button = $('#submit');
    const enabled = anyFileAttached() || $.trim(notes).length > 0;

    button.attr('disabled', !enabled);
  }

  function anyFileAttached() {
    for (let i = 0; i < 10; i++) {
      if (fileAttached(i)) {
        return true;
      }
    }

    return false;
  }

  function fileAttached(index) {
    const $fileChooser = $('#file_' + index + '_file');
    if ($fileChooser.length > 0 && $fileChooser.val()) {
      return true;
    } else if ($('#file_' + index + '_url').val()) {
      return true;
    }
  }

  function disableSubmit() {
    $('#submit').attr('disabled', true);
  }

  registerEvents();
  preventDefaultPlaceholderAnchorTags();
});
